import { LwStatusPill, type LwStatusTone } from '@/components/lw';
import type { FraudAlertReviewStatus } from '@/services/fraudAlertService';

const STATUS_PRESENTATION: Record<FraudAlertReviewStatus, { label: string; tone: LwStatusTone }> = {
  open: { label: 'Open', tone: 'destructive' },
  reviewed_false_alarm: { label: 'Reviewed — False Alarm', tone: 'neutral' },
  reviewed_amended_return_accurate: {
    label: 'Reviewed — Amended Return Accurate',
    tone: 'warning'
  }
};

export function FraudAlertStatusPill({ status }: { status: FraudAlertReviewStatus }) {
  const presentation = STATUS_PRESENTATION[status];
  return <LwStatusPill label={presentation.label} tone={presentation.tone} />;
}
